import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.NumericColumn("Año", "año", {headerCheckboxSelection: true,checkboxSelection:true}),
    ColumnsFactory.TextColumn("Dni", "dni"),
    ColumnsFactory.TextColumn("Nombre", "usuario"),
    ColumnsFactory.TextColumn("CP", "idCP"),
    ColumnsFactory.DecimalColumn("Indirectos (%)", "porcentajeIndirectos", {ipkTotalizar: false}),
    // ColumnsFactory.DecimalColumn("Costo/Hora", "costoHora", {ipkTotalizar: false}),
    ColumnsFactory.DecimalColumn("Costo Directo", "costoDirecto",{ipkTotalizar: false}),
    ColumnsFactory.DecimalColumn("Costo Total", "costoTotal",{ipkTotalizar: false})
  ];
};